module.exports = __webpack_public_path__ + "assets/img/zhongtong.ac211a74.png";